"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabSize = exports.AlignTabs = exports.CustomTab = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AlignTabs;
(function (AlignTabs) {
    AlignTabs["START"] = "start";
    AlignTabs["CENTER"] = "center";
    AlignTabs["END"] = "end";
})(AlignTabs || (AlignTabs = {}));
exports.AlignTabs = AlignTabs;
var TabSize;
(function (TabSize) {
    TabSize["XS"] = "XS";
    TabSize["S"] = "S";
    TabSize["M"] = "M";
    TabSize["L"] = "L";
    TabSize["XL"] = "XL";
})(TabSize || (TabSize = {}));
exports.TabSize = TabSize;
var sizeConfig = (_a = {},
    _a[TabSize.XS] = { iconSize: 15, fsClass: "fs-5" },
    _a[TabSize.S] = { iconSize: 20, fsClass: "fs-4" },
    _a[TabSize.M] = { iconSize: 25, fsClass: "fs-3" },
    _a[TabSize.L] = { iconSize: 30, fsClass: "fw-bolder fs-2" },
    _a[TabSize.XL] = { iconSize: 35, fsClass: "fw-bolder fs-1" },
    _a);
var CustomTab = function (_a) {
    var _b;
    var tabs = _a.tabs, defaultActiveKey = _a.defaultActiveKey, _c = _a.align, align = _c === void 0 ? AlignTabs.CENTER : _c, _d = _a.transparent, transparent = _d === void 0 ? false : _d, _e = _a.isFullWidth, isFullWidth = _e === void 0 ? false : _e, _f = _a.isBasic, isBasic = _f === void 0 ? true : _f, _g = _a.size, size = _g === void 0 ? TabSize.M : _g;
    var _h = (0, react_1.useState)(defaultActiveKey || ((_b = tabs[0]) === null || _b === void 0 ? void 0 : _b.key) || ""), activeTabKey = _h[0], setActiveTabKey = _h[1];
    var alignmentClass = align === AlignTabs.CENTER
        ? "justify-content-center"
        : align === AlignTabs.END
            ? "justify-content-end"
            : "justify-content-start";
    var navStyle = transparent ? { background: "transparent" } : undefined;
    var _j = sizeConfig[size], iconSize = _j.iconSize, fsClass = _j.fsClass;
    return (react_1.default.createElement("div", { className: "m-3" },
        react_1.default.createElement(react_bootstrap_1.Tab.Container, { activeKey: activeTabKey, onSelect: function (tabKey) { var _a; return setActiveTabKey(tabKey || ((_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.key) || ""); } },
            react_1.default.createElement(react_bootstrap_1.Nav, { variant: "tabs", className: "d-flex ".concat(alignmentClass, " m-0"), style: __assign({ width: "100%" }, navStyle) }, tabs.map(function (tab) { return (react_1.default.createElement(react_bootstrap_1.Nav.Item, { key: tab.key, className: isFullWidth ? "flex-grow-1" : "", style: {
                    margin: isBasic ? "0 5px" : undefined,
                } }, isBasic ? (react_1.default.createElement("div", { onClick: function () { return setActiveTabKey(tab.key); }, className: "btn w-100 ".concat(activeTabKey === tab.key
                    ? "btn-primary"
                    : "btn-outline-primary"), style: {
                    padding: "10px 15px",
                    textAlign: "center",
                    border: "none",
                    borderRadius: "20px 20px 0 0",
                } }, tab.title)) : (react_1.default.createElement("div", { onClick: function () { return setActiveTabKey(tab.key); }, className: "card flex-fill ".concat(activeTabKey === tab.key ? "bg-primary" : "bg-soft-primary", " text-light"), style: {
                    padding: "0 5px",
                    textAlign: "center",
                    margin: "0 5px",
                    borderRadius: "20px 20px 0 0",
                    cursor: "pointer",
                } },
                react_1.default.createElement("div", { className: "card-body d-flex flex-column text-center justify-content-center" },
                    react_1.default.createElement("span", { style: { fontSize: iconSize } }, tab.icon || react_1.default.createElement(react_1.default.Fragment, null)),
                    react_1.default.createElement("span", { className: fsClass }, tab.title)))))); })),
            react_1.default.createElement(react_bootstrap_1.Tab.Content, { style: {
                    padding: "10px",
                    border: "10px solid transparent",
                    borderRadius: "".concat(isFullWidth ? "6px" : "20px"),
                    background: "linear-gradient(var(--bs-body-bg),var(--bs-body-bg)) padding-box, linear-gradient(180deg, rgba(var(--bs-primary-rgb), 1) 0%, rgba(var(--bs-primary-rgb), 0.1) 15%, rgba(var(--bs-primary-rgb), 0) 35%) border-box",
                } }, tabs.map(function (tab) { return (react_1.default.createElement(react_bootstrap_1.Tab.Pane, { eventKey: tab.key, key: tab.key }, tab.content)); })))));
};
exports.CustomTab = CustomTab;
exports.default = CustomTab;
